"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformProcessingResult = void 0;
const TransformObject_1 = require("./TransformObject");
class TransformProcessingResult extends TransformObject_1.TransformObject {
    constructor(parent, baseResult) {
        super(parent, {
            baseResult,
            innerResults: new Set(),
        }, undefined, new Set([TransformProcessingResult]));
    }
    add(child) {
        this.assertCanAdd(child);
        this._sharedData.innerResults.add(child);
    }
    compile() {
        const baseResult = this._sharedData.baseResult;
        const innerResults = (baseResult.innerResults ?? []).concat(Array.from(this._sharedData.innerResults).map((child) => child.compile()));
        return {
            ...baseResult,
            innerResults: innerResults.length > 0 ? innerResults : undefined,
        };
    }
}
exports.TransformProcessingResult = TransformProcessingResult;
//# sourceMappingURL=TransformProcessingResult.js.map